var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClass2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6717_573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38427 18C5.24395 18 5.17455 17.8296 5.27495 17.7316L10.4955 12.6344C10.5421 12.5914 10.568 12.5346 10.568 12.4756C10.568 12.4165 10.5421 12.3597 10.4955 12.3167L5.27799 7.26895C5.1769 7.17114 5.24613 7 5.3868 7H7.97321C8.01328 7.0011 8.05268 7.00924 8.08902 7.02395C8.12535 7.03866 8.15786 7.05962 8.18457 7.08556L13.5955 12.3167C13.6412 12.3577 13.6667 12.4124 13.6667 12.4694C13.6667 12.5264 13.6412 12.5812 13.5955 12.6222L8.18457 17.8656C8.16453 17.9011 8.13483 17.932 8.09801 17.9554C8.06119 17.9788 8.01836 17.9941 7.97321 18H5.38427Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6717_573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82585 18C9.68554 18 9.61614 17.8296 9.71654 17.7316L14.9371 12.6344C14.9837 12.5914 15.0096 12.5346 15.0096 12.4756C15.0096 12.4165 14.9837 12.3597 14.9371 12.3167L9.71958 7.26895C9.61849 7.17114 9.68772 7 9.82839 7H12.4148C12.4549 7.0011 12.4943 7.00924 12.5306 7.02395C12.5669 7.03866 12.5995 7.05962 12.6262 7.08556L18.0371 12.3167C18.0828 12.3577 18.1083 12.4124 18.1083 12.4694C18.1083 12.5264 18.0828 12.5812 18.0371 12.6222L12.6262 17.8656C12.6061 17.9011 12.5764 17.932 12.5396 17.9554C12.5028 17.9788 12.4599 17.9941 12.4148 18H9.82585Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6717_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(5 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6717_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(9.44159 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass2);
export default __webpack_public_path__ + "static/media/class-2.e2b9ec60c84433aaff1f38a78605c35d.svg";
export { ForwardRef as ReactComponent };